(function () {
  // Colapsa #filter-sort al cargar (independiente del setting expand_filters).
  function collapseSort() {
    var el = document.getElementById('filter-sort');
    if (el) el.removeAttribute('open');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapseSort);
  } else {
    collapseSort();
  }
})();
